
<div class="card">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <!-- Primary Information Section -->
    <div class="form-section mb-6" *ngIf="primaryFields.length > 0">
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <div class="flex items-center justify-between w-full">
              <span class="font-semibold text-lg">Primary Information</span>
              <p-button 
                label="View History" 
                [text]="true" 
                severity="secondary" 
                class="ml-auto mr-4"
                (click)="$event.stopPropagation(); openHistoryModal()">
              </p-button>
            </div>
          </p-accordion-header>
          <p-accordion-content>
            <app-dynamic-form
              [data]="primaryFields"
              [formGroup]="form"
              [gridSize]="6"
              [viewMode]="mode === 'view'"
              [fileNamesMap]="formFieldFileNamesMap"
              (fieldChanged)="onFormFieldChanged($event)"
              (searchQuery)="onSearchQuery($event)"
              (fileUploadRequested)="onFormFileUpload($event)"
              (fileDownloadRequested)="onFileDownloadRequested($event)"
            ></app-dynamic-form>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    <!-- Tabs for Warranty/AMC Details + Maintenance Details -->
    <p-tabs *ngIf="dynamicFormTabs.length > 0" [value]="0">
      <p-tablist>
        <p-tab *ngFor="let tab of dynamicFormTabs; let i = index" [value]="i">
          <span class="font-normal text-sm">{{ tab.title }}</span>
        </p-tab>
      </p-tablist>
      
      <p-tabpanels>
        <p-tabpanel *ngFor="let tab of dynamicFormTabs; let i = index" [value]="i">
          <ng-container>
            <div *ngFor="let subTab of tab.sub_tabs" class="mb-4">
              <ng-container *ngIf="subTab.content.length > 0 || subTab.sub_type === 'TABLE'">
                <h5 *ngIf="subTab.show_heading" class="mb-3 font-semibold">{{ subTab.name }}</h5>

                <!-- TABLE type sub-tab: render with item-dynamic-form -->
                <ng-container *ngIf="subTab.sub_type === 'TABLE'; else fieldSubTab">
                  <app-item-dynamic-form
                    *ngIf="subTab.key !== 'part_items' || showPartItemsTable"
                    [viewMode]="mode === 'view' || workDetailDataExists"
                    [formGroup]="form"
                    [tableKey]="subTab.key"
                    [tableArray]="getTableFormArray(subTab.key)"
                    [data]="subTab.content"
                    [optionsMap]="optionsMap"
                    [showAddRemoveButtons]="mode !== 'view' && !workDetailDataExists"
                    (fieldChanged)="onItemFieldChanged($event)">
                  </app-item-dynamic-form>
                </ng-container>

                <!-- FIELD type sub-tab: render with dynamic-form -->
                <ng-template #fieldSubTab>
                  <app-dynamic-form
                    *ngIf="subTab.content.length > 0"
                    [gridSize]="6"
                    [viewMode]="mode === 'view' || (mode === 'edit' && (tab.system_name === 'warranty_amc_details' || tab.system_name === 'maintenance_details'))"
                    [data]="subTab.content"
                    [formGroup]="form"
                    (fieldChanged)="onFormFieldChanged($event)"
                    (searchQuery)="onSearchQuery($event)"
                    (fileUploadRequested)="onFormFileUpload($event)"
                    (fileDownloadRequested)="onFileDownloadRequested($event)"
                    [fileNamesMap]="formFieldFileNamesMap"
                  ></app-dynamic-form>

                  <!-- Maintenance Schedule Table (custom read-only table) -->
                  <ng-container *ngFor="let tf of subTab.tableFields">
                    <div class="maintenance-schedule-table mt-6" *ngIf="tf.field_name === 'maintenance_schedule'">
                      <h6 class="text-sm font-semibold text-gray-800 mb-3">{{ tf.display_name }}</h6>
                      <div class="border border-gray-200 rounded-md overflow-hidden">
                        <table class="schedule-table w-full text-left bg-white" *ngIf="maintenanceScheduleData.length > 0">
                          <thead class="bg-gray-50 border-b border-gray-200">
                            <tr>
                              <th class="px-4 py-3 text-sm font-semibold text-gray-700 w-1/3">Select Vendor</th>
                              <th class="px-4 py-3 text-sm font-semibold text-gray-700 w-1/3">Schedule Date</th>
                              <th class="px-4 py-3 text-sm font-semibold text-gray-700 w-1/3">Remarks</th>
                            </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-100">
                            <tr *ngFor="let row of maintenanceScheduleData" class="hover:bg-gray-50">
                              <td class="px-4 py-3 text-sm text-gray-700">{{ row.vendor }}</td>
                              <td class="px-4 py-3 text-sm text-gray-700">{{ row.schedule_date }}</td>
                              <td class="px-4 py-3 text-sm text-gray-700">{{ row.remarks }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="maintenanceScheduleData.length === 0" class="p-6 text-center text-sm text-gray-500 bg-gray-50">
                          No maintenance schedule data available for this asset.
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-template>
              </ng-container>
            </div>
          </ng-container>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <!-- Bottom Action Bar -->
    <div class="save-container">
      <div class="flex items-center gap-3 ml-auto">
        <p-button 
          type="button" 
          [label]="mode === 'view' ? 'Back' : 'Cancel'" 
          styleClass="p-button-outlined p-button-secondary"
          (onClick)="goBack()" />
        <p-button
          *ngIf="mode !== 'view'"
          type="submit"
          [label]="mode === 'edit' ? 'Update' : 'Send'"
          [disabled]="isLoading || isSubmitting"
          [loading]="isSubmitting" />
      </div>
    </div>

  </form>
</div>

<!-- Loading state -->
<div *ngIf="isLoading" class="nf-overlay">
  <svg class="nf-spinner" viewBox="0 0 50 50">
    <circle class="nf-spinner__track" cx="25" cy="25" r="20"></circle>
    <circle class="nf-spinner__arc" cx="25" cy="25" r="20"></circle>
  </svg>
</div>

<!-- Asset History Modal -->
<app-asset-history-modal
  [(visible)]="historyModalVisible"
  [assetId]="selectedAssetId || assetId">
</app-asset-history-modal>
